export interface FlatNode {
    id: number;
    name: string;
    parent: number | null;
    [key: string]: any;
  }
  export interface TreeNode extends FlatNode {
    children: TreeNode[];
  }
  export interface TreeViewNode {
    id: number;
    label: string;
    children: TreeViewNode[];
  }
  
  export function buildTree(flatList: FlatNode[]): TreeNode[] {
    const map: Record<number, TreeNode> = {};
    const roots: TreeNode[] = [];
  
    flatList.forEach((item) => {
      map[item.id] = { ...item, children: [] };
    });
  
    flatList.forEach((item) => {
      if (item.parent !== null && map[item.parent]) {
        map[item.parent].children.push(map[item.id]);
      } else if (item.parent === null) {
        roots.push(map[item.id]);
      }
    });
  
    return roots;
  }
  
  export function findNodeWithChildren(tree: TreeNode[], id: number): TreeNode | null {
    for (const node of tree) {
      if (node.id === id) return node;
      if (node.children && node.children.length > 0) {
        const found = findNodeWithChildren(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }
  
  export function mapToTreeView(tree: TreeNode[]): TreeViewNode[] {
    return tree.map((n) => ({
      id: n.id,
      label: n.name,
      children: n.children ? mapToTreeView(n.children) : [],
    }));
  }
  